module.exports = __webpack_public_path__ + "77aa85fd3471a774a07cc09672bd250b.pdf";